import axios from "axios";
import { Url, geoApiUrl } from "../global";
import authHeader from "./auth-header";
import authCustomHeader from "./auth-custom-header";
import authFormHeader from "./auth-form";

const register = (username, email, password) => {
  return axios.post(
    Url + "signup",
    {
      username,
      email,
      password,
    },
    { timeout: process.env.REACT_APP_AXIOS_TIMEOUT },
  );
};

const login = async (username, password, captchaCode) => {
  try {
    const response = await axios.post(
      Url + "login",
      {
        username,
        password,
        captchaCode,
      },
      { timeout: process.env.REACT_APP_AXIOS_TIMEOUT }, //process.env.REACT_APP_AXIOS_TIMEOUT
    );
    localStorage.clear();
    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "1001"
    ) {
      // localStorage.setItem(
      //   "token",
      //   JSON.stringify(response.data.AccessToken)
      // );
      localStorage.setItem("token", JSON.stringify(response.data.AccessToken));
      localStorage.setItem("accountID", response.data.AccountID);
      localStorage.setItem("userID", JSON.stringify(response.data.UserID));
      localStorage.setItem(
        "businessName",
        JSON.stringify(response.data.BusinessName),
      );
      // localStorage.setItem(
      //   "expiresAt",
      //   JSON.stringify(response.data.ExpiresAt)
      // );
      localStorage.setItem(
        "expiresAt",
        JSON.stringify(response.data.ExpiresAt),
      );
      localStorage.setItem("name", JSON.stringify(response.data.Name));
      localStorage.setItem("roleID", response.data.roleID);
      localStorage.setItem("accountType", response.data.accountType);
      localStorage.setItem("accountTypeID", response.data.AccountTypeID);
      if (
        response.data.accountType !== "MST" &&
        response.data.accountType !== "MNU"
      ) {
        await axios
          .get(Url + "Api/getAccountStateID", { headers: authHeader() })
          .then((response_1) => {
            if (
              response_1.data.apiResponseCode &&
              response_1.data.apiResponseCode == "1001"
            ) {
              localStorage.setItem("stateID", response_1.data.stateID);

              localStorage.setItem("stateName", response_1.data.stateName);

              if (localStorage.getItem("accountType") == "RTO") {
                localStorage.setItem("rtoID", response_1.data.rtoID);
              }
            }
          });
      }
      localStorage.setItem("localStorage", JSON.stringify(localStorage));
    }
    return await response.data;
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const refreshToken = async () => {
  const response = await axios.get(Url + "refreshToken", {
    headers: authHeader(),
    timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
  });
  if (
    response.data.ApiResponseCode &&
    response.data.ApiResponseCode == "1001"
  ) {
    // localStorage.setItem(
    //   "token",
    //   JSON.stringify(response.data.AccessToken)
    // );
    localStorage.setItem("token", JSON.stringify(response.data.AccessToken));

    // localStorage.setItem(
    //   "ExpiresAt",
    //   JSON.stringify(response.data.ExpiresAt)
    // );
    localStorage.setItem("ExpiresAt", JSON.stringify(response.data.ExpiresAt));
    localStorage.setItem("localStorage", JSON.stringify(localStorage));
  } else if (
    response.data.ApiResponseCode &&
    response.data.ApiResponseCode == "999"
  ) {
    // localStorage.removeItem("token");
    localStorage.clear();
    window.location.replace("/login");
  }
  return response.data;
};

const postJsonData = async (apiURL, jsonData = {}) => {
  const formData = jsonData;
  if (formData.stateID == undefined) {
    jsonData.stateID = parseInt(localStorage.getItem("stateID"));
  }
  try {
    const response = await axios.post(Url + apiURL, jsonData, {
      headers: authHeader(),
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT, //30000 process.env.REACT_APP_AXIOS_TIMEOUT
    });

    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "3001"
    ) {
      // localStorage.removeItem("token")
      // localStorage.setItem('localStorage', JSON.stringify(localStorage));
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "999"
    ) {
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else {
      return response.data;
    }
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const reportPostJsonData = async (apiURL, jsonData = {}) => {
  const formData = jsonData;
  if (formData.stateID == undefined) {
    jsonData.stateID = parseInt(localStorage.getItem("stateID"));
  }
  try {
    const response = await axios.post(Url + apiURL, jsonData, {
      headers: authHeader(),
      timeout: process.env.REACT_APP_AXIOS_REPORT_TIMEOUT, //30000 process.env.REACT_APP_AXIOS_TIMEOUT
    });

    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "3001"
    ) {
      // localStorage.removeItem("token")
      // localStorage.setItem('localStorage', JSON.stringify(localStorage));
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "999"
    ) {
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else {
      return response.data;
    }
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const postFormData = async (apiURL, formData) => {
  try {
    const response = await axios.post(Url + apiURL, formData, {
      headers: authFormHeader(),
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
    });
    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "3001"
    ) {
      //localStorage.removeItem("token")
      //  localStorage.setItem('localStorage', JSON.stringify(localStorage));
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "999"
    ) {
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else {
      return response.data;
    }
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const getJsonData = async (apiURL) => {
  try {
    const response = await axios.get(Url + apiURL, {
      headers: authHeader(),
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
    });
    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "3001"
    ) {
      // localStorage.removeItem("token")
      //  localStorage.setItem('localStorage', JSON.stringify(localStorage));
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "999"
    ) {
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else {
      return response.data;
    }
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const reportGetJsonData = async (apiURL) => {
  try {
    const response = await axios.get(Url + apiURL, {
      headers: authHeader(),
      timeout: process.env.REACT_APP_AXIOS_REPORT_TIMEOUT,
    });
    if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "3001"
    ) {
      // localStorage.removeItem("token")
      //  localStorage.setItem('localStorage', JSON.stringify(localStorage));
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else if (
      response.data.ApiResponseCode &&
      response.data.ApiResponseCode == "999"
    ) {
      // localStorage.removeItem("token");
      localStorage.clear();
      window.location.replace("/login");
    } else {
      return response.data;
    }
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const getActivateData = async (apiURL, token) => {
  try {
    const response = await axios.get(Url + apiURL, {
      headers: authCustomHeader(token),
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
    });
    return response.data;
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const getThirdPartApi = async (apiURL) => {
  const response = await axios.get(apiURL, {
    timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
  });
  return response.data;
};

const postActivateData = async (apiURL, jsonData, token) => {
  try {
    const response = await axios.post(Url + apiURL, jsonData, {
      headers: authCustomHeader(token),
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
    });
    return response.data;
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const logout = () => {
  // localStorage.removeItem("token");
  localStorage.clear();
};

const getAddressFromGeoAPI = async (lat, lng) => {
  var apiURL =
    geoApiUrl +
    "?lat=" +
    lat +
    "&lng=" +
    lng +
    "&key=AIzaSyDaXKBNs7JYMIyuG5u040qhr5FmrobTHWE";
  try {
    const response = await axios.get(apiURL, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT, //process.env.REACT_APP_AXIOS_TIMEOUT
    });
    if (
      response.data.response_code != "2001" ||
      response.data.response_code != 2001
    ) {
      return response.data.address;
    } else {
      return "NA";
    }
  } catch (error) {
    let Errordata = {
      response_code: 1003,
      msg: "Unable to process your request, Please Try Later.",
      address: "N/A",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.msg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.msg = "Unable to process your request, Please Try Later.";
    }
    return Errordata.address;
  }
};

const checkResponseApi = async (apiURL) => {
  try {
    const response = await axios.get(Url + apiURL, {
      timeout: process.env.REACT_APP_AXIOS_TIMEOUT,
    });
    return response;
  } catch (error) {
    let Errordata = {
      apiResponseCode: "1003",
      apiResponseMsg: "Unable to process your request, Please Try Later.",
    };
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
      Errordata.apiResponseMsg = "Request has been canceled";
    } else if (error.code === "ECONNABORTED") {
      console.warn("Request timeOut:");
      Errordata.apiResponseMsg =
        "Unable to process your request, Please Try Later.";
    }
    return Errordata;
  }
};

const authservice = {
  register,
  login,
  logout,
  postJsonData,
  getJsonData,
  reportPostJsonData,
  reportGetJsonData,
  refreshToken,
  getActivateData,
  postActivateData,
  postFormData,
  getThirdPartApi,
  getAddressFromGeoAPI,
  checkResponseApi,
};
export default authservice;
